import { render, staticRenderFns } from "./ku-login.vue?vue&type=template&id=1fffb430&scoped=true"
import script from "./ku-login.vue?vue&type=script&lang=js"
export * from "./ku-login.vue?vue&type=script&lang=js"
import style0 from "./ku-login.vue?vue&type=style&index=0&id=1fffb430&prod&lang=scss"
import style1 from "./ku-login.vue?vue&type=style&index=1&id=1fffb430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffb430",
  null
  
)

export default component.exports